import { useShallow } from 'zustand/shallow'
import {
  selectBuilder,
  selectBuilderActions,
  selectDealerFits,
  selectDealerFitsActions,
  selectFactoryFits,
  selectFactoryFitsActions,
  selectServiceContract,
  selectServiceContractActions,
  selectTransportType,
  selectTransportTypeActions,
  selectUI,
  selectUIActions,
  selectWarranty,
  selectWarrantyActions
} from '../selectors'
import { useEquipmentStore } from '../store'

export const useBuilder = () => {
  const state = useEquipmentStore(useShallow(selectBuilder))
  const actions = useEquipmentStore(useShallow(selectBuilderActions))
  return { ...state, ...actions }
}

export const useFactoryFits = () => {
  const state = useEquipmentStore(useShallow(selectFactoryFits))
  const actions = useEquipmentStore(useShallow(selectFactoryFitsActions))
  return { ...state, ...actions }
}

export const useDealerFitsS = () => {
  const state = useEquipmentStore(useShallow(selectDealerFits))
  const actions = useEquipmentStore(useShallow(selectDealerFitsActions))
  return { ...state, ...actions }
}

export const useWarranty = () => {
  const state = useEquipmentStore(useShallow(selectWarranty))
  const actions = useEquipmentStore(useShallow(selectWarrantyActions))
  return { ...state, ...actions }
}

export const useUI = () => {
  const state = useEquipmentStore(useShallow(selectUI))
  const actions = useEquipmentStore(useShallow(selectUIActions))
  return { ...state, ...actions }
}

export const useTransportType = () => {
  const state = useEquipmentStore(useShallow(selectTransportType))
  const actions = useEquipmentStore(useShallow(selectTransportTypeActions))
  return { ...state, ...actions }
}

export const useServiceContract = () => {
  const state = useEquipmentStore(useShallow(selectServiceContract))
  const actions = useEquipmentStore(useShallow(selectServiceContractActions))
  return { ...state, ...actions }
}
